import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { useMutation } from 'react-query';
import commonGenerateReport from './Report.service';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useCommonGenerateReport<T extends Record<string, any>>(
  URL = '',
  message: string,
  description: string,
  isIntl?: boolean,
) {
  const intl = (text: string) => useIntl().formatMessage({ id: text });
  const mutation = useMutation(
    ({ url, ...obj }: T) => commonGenerateReport(url || URL, obj),
    {
      onSuccess() {
        notification.success({
          message: isIntl ? intl(message) : message,
          description: isIntl ? intl(description) : description,
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
